// Patterns for Sentry's `ignoreErrors`: exceptions raised on our pages by a
// script the *browser* injected, never by our bundle.
//
// On iOS every browser is a WebKit wrapper, and several of them — Brave
// included — carry Firefox-for-iOS code that reaches for the `window.__firefox__`
// object behind reader mode. When it is not there the injected script throws on
// our page, the global `onerror` handler picks it up, and Sentry files it as
// ours. In #440 that produced four groups from a single visitor in 21 minutes,
// all on `/autorizacao/entrar` — the most visited page we have, so the noise
// grows with traffic.
//
// The signature is unmistakable, and none of it is ours: `mechanism: onerror`,
// a single-frame stacktrace at line 1 of the document (i.e. injected, not a
// bundle frame), and a name our code never mentions — `grep -r __firefox__
// front/src` finds nothing, which is what makes filtering on it safe.
//
// KEEP THIS LIST NARROW. Anything matched here is dropped in the browser and is
// invisible from Sentry afterwards, so a pattern that is too wide silently
// hides real bugs — the opposite of what #421 (the 5xx logging floor) and #433
// (a `console.error` raises no Sentry event) set out to achieve. In particular,
// do not filter on `mechanism: onerror` itself: that is also how genuine
// unhandled application errors arrive.
//
// Matching follows Sentry's own semantics — each pattern is tested against the
// event message and the exception value (`InboundFilters` via
// `getPossibleEventMessages`), so `/__firefox__/` covers every variant observed:
// `window.__firefox__.reader`, `Can't find variable: __firefox__`, and
// `window.__firefox__.refresh_youtube_quality_*`.
export const sentryIgnoreErrors = [/__firefox__/]
